/**
 * Flattens the preview workout items into:
 *  - `flat`: the navigable list of exercise objects (session-break sub-items hoisted
 *    into the same index space, breaks themselves excluded), used by the detail view.
 *  - `rendered`: the ordered render list for the sidebar. Each entry is either a top-level
 *    `exercise` (carrying its index into `flat`) or a `break` section that nests its
 *    grouped `children` (each an `exercise` entry carrying its own `flat` index).
 *
 * Mirrors the index semantics of the workouts module's `workoutsMapper`
 * (WorkoutsList.js) so clicking an item opens the matching detail card.
 */
const flattenPreviewWorkouts = (items = []) => {
  const flat = [];
  const rendered = [];

  items.forEach((item) => {
    if (item.type === 'BR') {
      const children = (item.sessionBreakItems || []).map((subItem) => {
        const entry = { kind: 'exercise', item: subItem, flatIndex: flat.length };
        flat.push(subItem);
        return entry;
      });
      rendered.push({ kind: 'break', item, children });
    } else {
      rendered.push({ kind: 'exercise', item, flatIndex: flat.length });
      flat.push(item);
    }
  });

  return { flat, rendered };
};

export default flattenPreviewWorkouts;
